<template>
    <rkm-modal
        extra-large
        persistent
        ref="RkmModal"
        title="Declaração de comparecimento"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="data.form.declaracaoComparecimento.turnos"
                        @change="handleTurnoChange"
                        default-option-text="Horário personalizado"
                        label="Turno"
                        show-default-option
                        text-field="nome"
                        v-model="model.turnoId"
                        value-field="id"
                    />
                </rkm-col>

                <template v-if="model.turnoId === null">
                    <rkm-col cols="3">
                        <rkm-form-time-picker
                            :validations="validations.entrada"
                            label="Hora da entrada"
                            v-model="model.entrada"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-time-picker
                            :validations="validations.saida"
                            label="Hora da saída"
                            v-model="model.saida"
                        />
                    </rkm-col>
                </template>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.nomeAcompanhante"
                        label="Nome do acompanhante"
                        uppercase
                        v-model="model.nomeAcompanhante"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :validations="validations.motivoComparecimento"
                        label="Motivo do comparecimento"
                        rows="4"
                        maxlength="1500"
                        v-model="model.motivoComparecimento"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{item ? 'Salvar' : 'Incluir'}}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {formats, object} from '@/mixins'

export default {
    computed: {
        validations() {
            return {
                entrada: {
                    required: true,
                    max_hour: this.model.saida ? this.formatTime(this.model.saida) : null,
                },
                saida: {
                    required: true,
                    min_hour: this.model.entrada ? this.formatTime(this.model.entrada) : null,
                },
                nomeAcompanhante: {max: 150},
                motivoComparecimento: {max: 1500},
            }
        },
    },
    data: () => ({
        item: null,
        model: {
            turnoId: null,
            entrada: null,
            saida: null,
            nomeAcompanhante: null,
            motivoComparecimento: null,
        },
    }),
    methods: {
        open(item = null) {
            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()

            this.model.entrada = this.data.additionals.horaInicioAtendimento
            this.model.saida = this.data.additionals.horaInicioAtendimento
        },
        edit() {
            this.model = this.clone({
                turnoId: this.item.turno ? this.item.turno.id : null,
                entrada: this.item.entrada,
                saida: this.item.saida,
                nomeAcompanhante: this.item.nomeAcompanhante,
                motivoComparecimento: this.item.motivoComparecimento,
            })
        },
        store() {
            const turno = this.data.form.declaracaoComparecimento.turnos.find(turno => turno.id === this.model.turnoId)

            this.data.model.declaracoesComparecimento.push({
                turno: this.model.turnoId ? {
                    id: turno.id,
                    nome: turno.nome,
                } : null,
                entrada: this.model.entrada ? this.formatTime(this.model.entrada) : null,
                saida: this.model.saida ? this.formatTime(this.model.saida) : null,
                nomeAcompanhante: this.model.nomeAcompanhante,
                motivoComparecimento: this.model.motivoComparecimento,
            })
        },
        update() {
            const turno = this.data.form.declaracaoComparecimento.turnos.find(turno => turno.id === this.model.turnoId)

            Object.assign(this.item, {
                turno: this.model.turnoId ? {
                    id: turno.id,
                    nome: turno.nome,
                } : null,
                entrada: this.model.entrada ? this.formatTime(this.model.entrada) : null,
                saida: this.model.saida ? this.formatTime(this.model.saida) : null,
                nomeAcompanhante: this.model.nomeAcompanhante,
                motivoComparecimento: this.model.motivoComparecimento,
            })
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.item) {
                        this.update()
                    } else {
                        this.store()
                    }

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.model.turnoId = null
            this.model.entrada = null
            this.model.saida = null
            this.model.nomeAcompanhante = null
            this.model.motivoComparecimento = null
        },
        handleTurnoChange() {
            this.model.entrada = null
            this.model.saida = null
        },
    },
    mixins: [formats, object],
    props: {
        data: {type: Object, required: true},
    },
}
</script>